import React from 'react';
import LookUp from '../LookUp/LookUp';

class LookUpV2 extends LookUp {
	constructor(props) {
        super(props);
    }
   
}

export default LookUpV2;


// WEBPACK FOOTER //
// ./src/components/Field_Components/LookUpV2/LookUpV2.js